import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PAYMENT_LINK = "https://buy.stripe.com/7sY5kC9tWdcw69tcPD14400";

// Redirect to the hosted Stripe Payment Link ($2/mo). Prefill the account email
// and pass client_reference_id so the webhook can map the payment to the user.
export function startCheckout(email = null, clientRef = null) {
  const params = new URLSearchParams();
  if (email) params.set("prefilled_email", email);
  if (clientRef) params.set("client_reference_id", clientRef);
  const qs = params.toString();
  window.location.href = qs ? `${PAYMENT_LINK}?${qs}` : PAYMENT_LINK;
  return true;
}

export async function cancelSubscription() {
  const res = await axios.post(`${API}/subscription/cancel`, {}, { withCredentials: true });
  return res.data;
}

export async function syncSubscription() {
  const res = await axios.post(`${API}/subscription/sync`, {}, { withCredentials: true });
  return res.data;
}
